export default __webpack_public_path__ + "static/media/commodities.f2b94d5e.svg";